import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

const withdrawalSchema = z.object({
  /** Withdraw ID */
  withdrawId: z.string(),
  /** Transaction ID. It returns "" when withdrawal failed, withdrawal cancelled */
  txID: z.string(),
  /** Withdraw type. 0: on chain. 1: off chain */
  withdrawType: z.union([z.literal(0), z.literal(1)]),
  /** Coin */
  coin: z.string(),
  /** Chain */
  chain: z.string(),
  /** Amount */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Withdraw fee */
  withdrawFee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Withdraw status */
  status: z.union([
    z.literal('SecurityCheck'),
    z.literal('Pending'),
    z.literal('success'),
    z.literal('CancelByUser'),
    z.literal('Reject'),
    z.literal('Fail'),
    z.literal('BlockchainConfirmed'),
    z.literal('MoreInformationRequired'),
    z.literal('Unknown'),
  ]),
  /** To withdrawal address. Shows the Bybit UID for internal transfers */
  toAddress: z.string(),
  /** Tag */
  tag: z.string().nullable(),
  /** Withdraw created timestamp (ms) */
  createTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** Withdraw updated timestamp (ms) */
  updateTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type Withdrawal = z.infer<typeof withdrawalSchema>

export const withdrawalResultSchema = z.object({
  rows: z.array(withdrawalSchema),
  nextPageCursor: z.string().nullable(),
})
